import {useLocation, useNavigate} from "react-router-dom";
import MainLayout from "../../../commons/layout/MainLayout";
import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import Button from "../../../commons/components/Button";
import PhotoSelector from "../../../commons/components/Forms/PhotoSelector";
import Slider from "../../../commons/components/Slider";
import ROUTERS from "../../../commons/constans/router";
import {Fragment, useEffect, useState} from "react";
import _styles from "./styles.scss"
import {useSelector} from "react-redux";
import SkeletonLoadingComponent from "../../../commons/components/SkeletonLoading";




const InfoService = ({informationData,title,changePage,loadingData}) => {

  const {userInfo, token, type} = useSelector((state) => state.authReducers);
  const navigate = useNavigate();

  const handleLeftClick = () => {
    if(userInfo.id){
      navigate(ROUTERS.HOME, {
        state: {
          menuStatus: true
        }
      });
    }else{
      changePage('register');
    }
  }
  const [listData, setListData] = useState([])

  useEffect(() => {
    setListData(informationData?.data || [])
  }, [informationData?.data]);



  return (
    <MainLayout
      pageID={"information"} displayBottomNav={false}
    >
      <HeaderHs2
        labelRight={false}
        labelLeft={true}
        title={title}
        handleLabelLeft={() => handleLeftClick()}
      />

      <div className="wrapper">
        
        {loadingData ? (
          <Fragment >
          <div className="container" >
            <h3 className="title">
              <SkeletonLoadingComponent cssClass='title' circle={false} width="100%" height="14px"/>
            </h3>
          </div>

          <div className="main-content">
            <p className="main-content__detail">
            <SkeletonLoadingComponent circle={false} width="100%" height="14px"/>
            </p>
          </div>
        </Fragment>
        ) : (listData.length > 0 && listData.map((item,key)=>(
            <Fragment key={key}>
              <div className="container" >
                <h3 className="title">{item.title}</h3>
              </div>

              <div className="main-content">
                <p className="main-content__detail">
                  {item.content}
                </p>
              </div>
            </Fragment>
        )))}


      </div>

    </MainLayout>
  )
}

InfoService.defaultProps = {
  informationData : [],
  title : '',
  changePage : () => {},
  loadingData : false
}

export default InfoService;